import { Injectable } from '@angular/core';
import { BASE_API_URL, IReview } from '@curbnturf/entities';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'rating';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  constructor(private cachedHttp: CachedHttpClient) {}

  fetchAll(siteId: number): Observable<IReview> {
    if (!siteId) {
      throw new Error('Unable to fetch reviews. No site ID provided');
    }

    return this.cachedHttp.get<IReview>(`${API_URL}/site/${siteId}/review`, { cachableResponse: true });
  }

  createBoondockReview(review: IReview, boondockSiteId: number): Observable<IReview> {
    return this.cachedHttp.post<IReview>(
      `${API_URL}/boondock/${boondockSiteId}/review`,
      review,
      { cachableResponse: false },
      { offlineCallback: () => ({ ...review, id: -1 }) },
    );
  }

  createGuestReview(review: IReview, guestId: number): Observable<IReview> {
    return this.cachedHttp.post<IReview>(
      `${API_URL}/guest/${guestId}/review`,
      review,
      { cachableResponse: false },
      { offlineCallback: () => ({ ...review, id: -1 }) },
    );
  }

  createPoiReview(review: IReview, poiId: number): Observable<IReview> {
    return this.cachedHttp.post<IReview>(
      `${API_URL}/poi/${poiId}/review`,
      review,
      { cachableResponse: false },
      { offlineCallback: () => ({ ...review, id: -1 }) },
    );
  }

  createListingReview(review: IReview, listingId: number): Observable<IReview> {
    return this.cachedHttp.post<IReview>(
      `${API_URL}/listing/${listingId}/review`,
      review,
      { cachableResponse: false },
      { offlineCallback: () => ({ ...review, id: -1 }) },
    );
  }

  loadListingReviews(listingId: number): Observable<IReview[]> {
    return this.cachedHttp.get<IReview[]>(`${API_URL}/listing/${listingId}/review`, { cachableResponse: true });
  }

  loadGuestReviews(guestId: number): Observable<IReview[]> {
    return this.cachedHttp.get<IReview[]>(`${API_URL}/guest/${guestId}/review`, { cachableResponse: true });
  }

  loadBoondockReviews(boondockId: number): Observable<IReview[]> {
    return this.cachedHttp.get<IReview[]>(`${API_URL}/boondock/${boondockId}/review`, { cachableResponse: true });
  }

  loadPoiReviews(activityId: number): Observable<IReview[]> {
    return this.cachedHttp.get<IReview[]>(`${API_URL}/poi/${activityId}/review`, { cachableResponse: true });
  }
}
